"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefinedAnalysisDtoConfidenceEnum = void 0;
exports.instanceOfRefinedAnalysisDto = instanceOfRefinedAnalysisDto;
exports.RefinedAnalysisDtoFromJSON = RefinedAnalysisDtoFromJSON;
exports.RefinedAnalysisDtoFromJSONTyped = RefinedAnalysisDtoFromJSONTyped;
exports.RefinedAnalysisDtoToJSON = RefinedAnalysisDtoToJSON;
exports.RefinedAnalysisDtoToJSONTyped = RefinedAnalysisDtoToJSONTyped;
var AdjustmentFactorDto_1 = require("./AdjustmentFactorDto");
/**
 * @export
 */
exports.RefinedAnalysisDtoConfidenceEnum = {
    High: 'high',
    Medium: 'medium',
    Low: 'low'
};
/**
 * Check if a given object implements the RefinedAnalysisDto interface.
 */
function instanceOfRefinedAnalysisDto(value) {
    if (!('adjustedEstimate' in value) || value['adjustedEstimate'] === undefined)
        return false;
    if (!('confidence' in value) || value['confidence'] === undefined)
        return false;
    if (!('reasoning' in value) || value['reasoning'] === undefined)
        return false;
    return true;
}
function RefinedAnalysisDtoFromJSON(json) {
    return RefinedAnalysisDtoFromJSONTyped(json, false);
}
function RefinedAnalysisDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'adjustedEstimate': json['adjustedEstimate'],
        'confidence': json['confidence'],
        'adjustmentFactors': json['adjustmentFactors'] == null ? undefined : (json['adjustmentFactors'].map(AdjustmentFactorDto_1.AdjustmentFactorDtoFromJSON)),
        'reasoning': json['reasoning'],
    };
}
function RefinedAnalysisDtoToJSON(json) {
    return RefinedAnalysisDtoToJSONTyped(json, false);
}
function RefinedAnalysisDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'adjustedEstimate': value['adjustedEstimate'],
        'confidence': value['confidence'],
        'adjustmentFactors': value['adjustmentFactors'] == null ? undefined : (value['adjustmentFactors'].map(AdjustmentFactorDto_1.AdjustmentFactorDtoToJSON)),
        'reasoning': value['reasoning'],
    };
}
